import { render, staticRenderFns } from "./ShareFiles.vue?vue&type=template&id=18a6b3d0&scoped=true&"
import script from "./ShareFiles.vue?vue&type=script&lang=js&"
export * from "./ShareFiles.vue?vue&type=script&lang=js&"
import style0 from "./ShareFiles.vue?vue&type=style&index=0&id=18a6b3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6b3d0",
  null
  
)

export default component.exports